<template>
  <div class="configuration-options d-flex flex-wrap">
    <div class="first-column" :class="[ layout === '2-columns' ? 'w-40': 'w-25']">
      <slot name="first" />
    </div>
    <div class="second-column" :class="[ layout === '2-columns' ? 'w-60 pl-5': 'w-25']">
      <slot name="second" />
    </div>
    <div class="third-column" :class="[ layout === '2-columns' ? 'w-full': 'w-25']">
      <slot name="third" />
    </div>
    <div class="third-column" :class="[ layout === '2-columns' ? 'w-full': 'w-25']">
      <slot name="fourth" />
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    layout: {
      type: String,
      default: '2-columns',
      validator: value => ['2-columns', '4-columns'].includes(value)
    }
  }
}
</script>

<style>
.w-60 {
  width: 60%;
}

.w-40 {
  width: 40%
}
</style>
